import { render, staticRenderFns } from "./selectCar.vue?vue&type=template&id=71264058&scoped=true&"
import script from "./selectCar.vue?vue&type=script&lang=js&"
export * from "./selectCar.vue?vue&type=script&lang=js&"
import style0 from "./selectCar.vue?vue&type=style&index=0&id=71264058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71264058",
  null
  
)

export default component.exports